<template>
  <div>
    <v-expansion-panels accordion multiple class="custom-panel mt-5">
      <v-expansion-panel>
        <v-expansion-panel-header> พื้นหลัง </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat class="px-4">
            <v-card-text class="pa-0 my-3"> สีพื้นหลัง </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="welcome_theme.bg_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-card-text class="pa-0 my-3"> รูปภาพพื้นหลัง </v-card-text>
            <v-card-text class="px-0">
              <v-card v-show="!welcome_theme.bg_image" class="pl-2" flat>
                <input
                  ref="bgimage"
                  type="file"
                  accept="image/*"
                  @change="BGImage()"
                  tabindex="-1"
                  class="d-none"
                />
                <v-btn @click="$refs.bgimage.click()">
                  <v-icon small class="mr-2">mdi-image</v-icon>
                  เลือกรูปภาพ
                </v-btn>
              </v-card>
              <v-card v-show="welcome_theme.bg_image" class="pl-2" flat>
                <v-card flat>
                  <v-card-title class="pa-1">
                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      color="#DE4F3B"
                      @click="welcome_theme.bg_image = false"
                      ><v-icon>clear</v-icon></v-btn
                    >
                  </v-card-title>
                  <v-card-text class="d-flex justify-center">
                    <img :src="welcome_theme.bg_image_url" width="100" />
                  </v-card-text>
                  <v-card-text>
                    <v-btn
                      color="primary"
                      outlined
                      block
                      @click="$refs.bgimage.click()"
                      >เปลี่ยนรูป</v-btn
                    >
                  </v-card-text>
                  <v-card-text>
                    <v-radio-group
                      v-model="welcome_theme.bg_repeat"
                      hide-details=""
                    >
                      <template v-slot:label> ปรับรูปภาพพื้นหลัง </template>
                      <v-radio value="repeat">
                        <template v-slot:label>
                          <div>รูปภาพซ้ำปกติ</div>
                        </template>
                      </v-radio>
                      <v-radio value="repeat-x">
                        <template v-slot:label>
                          <div>รูปภาพซ้ำไปทางแนวนอน</div>
                        </template>
                      </v-radio>
                      <v-radio value="repeat-y">
                        <template v-slot:label>
                          <div>รูปภาพซ้ำไปทางแนวตั้ง</div>
                        </template>
                      </v-radio>
                      <v-radio value="no-repeat">
                        <template v-slot:label>
                          <div>รูปภาพไม่ซ้ำ</div>
                        </template>
                      </v-radio>
                      <v-radio value="space">
                        <template v-slot:label>
                          <div>รูปภาพซ้ำแบบมีช่องว่าง</div>
                        </template>
                      </v-radio>
                      <v-radio value="round">
                        <template v-slot:label>
                          <div>รูปภาพซ้ำแบบพอดีหน้าจอ</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <v-radio-group
                      v-model="welcome_theme.bg_size"
                      hide-details=""
                    >
                      <template v-slot:label> รูปแบบภาพพื้นหลัง </template>
                      <v-radio value="auto">
                        <template v-slot:label>
                          <div>อัตโนมัติ</div>
                        </template>
                      </v-radio>
                      <v-radio value="100% 100%">
                        <template v-slot:label>
                          <div>พอดีหน้าจอ</div>
                        </template>
                      </v-radio>
                      <v-radio value="cover">
                        <template v-slot:label>
                          <div>เต็มจอตามความยาวรูปภาพ</div>
                        </template>
                      </v-radio>
                      <v-radio value="contain">
                        <template v-slot:label>
                          <div>เต็มจอตามความสูงรูปภาพ</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <v-radio-group
                      v-model="welcome_theme.bg_position_x"
                      hide-details=""
                    >
                      <template v-slot:label>
                        การจัดวางตามแกน x (แนวนอน)
                      </template>
                      <v-radio value="left">
                        <template v-slot:label>
                          <div>ซ้าย</div>
                        </template>
                      </v-radio>
                      <v-radio value="center">
                        <template v-slot:label>
                          <div>กลาง</div>
                        </template>
                      </v-radio>
                      <v-radio value="right">
                        <template v-slot:label>
                          <div>ขวา</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <v-radio-group
                      v-model="welcome_theme.bg_position_y"
                      hide-details=""
                    >
                      <template v-slot:label>
                        การจัดวางตามแกน y (แนวตั้ง)
                      </template>
                      <v-radio value="top">
                        <template v-slot:label>
                          <div>บน</div>
                        </template>
                      </v-radio>
                      <v-radio value="center">
                        <template v-slot:label>
                          <div>กลาง</div>
                        </template>
                      </v-radio>
                      <v-radio value="bottom">
                        <template v-slot:label>
                          <div>ล่าง</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header> รูปแบบ Header </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card v-show="!welcome_theme.image" class="pl-2" flat>
            <input
              ref="webformimage"
              type="file"
              accept="image/*"
              @change="WebformImage()"
              tabindex="-1"
              class="d-none"
            />
            <v-btn @click="$refs.webformimage.click()">
              <v-icon small class="mr-2">mdi-image</v-icon>
              เลือกรูปภาพ
            </v-btn>
          </v-card>
          <v-card v-show="welcome_theme.image" class="pl-2" flat>
            <v-card flat>
              <v-card-title class="pa-1">
                <!-- <v-btn icon @click="PopupCrop">
                  <v-icon size="20">crop</v-icon>
                </v-btn>
                <CropImage
                  :image_url="welcome_theme.image_url"
                  filepath="welcome_theme"
                  ref="cropimage"
                  @croped="(img) => (welcome_theme.image_url = img)"
                /> -->
                <v-spacer></v-spacer>
                <v-btn icon color="#DE4F3B" @click="ClearLogoImage"
                  ><v-icon>clear</v-icon></v-btn
                >
              </v-card-title>
              <v-card-text class="d-flex justify-center">
                <img :src="welcome_theme.image_url" width="100" />
              </v-card-text>
              <v-card-text>
                <v-btn
                  color="#2A9CD4"
                  outlined
                  block
                  @click="$refs.webformimage.click()"
                  >เปลี่ยนรูป</v-btn
                >
              </v-card-text>
              <v-card-text class="py-0"> ขนาดรูป Banner </v-card-text>
              <v-card-text class="pl-2">
                <span v-if="mobile_mode">*จะแสดงรูปเต็มความยาวใน mobile</span>
                <v-slider
                  v-model="LogoSizeChange"
                  min="25"
                  max="100"
                  step="1"
                  hide-details=""
                  :disabled="mobile_mode"
                >
                  <template #append>
                    <v-btn
                      class="mt-n1"
                      @click="LZoomIn"
                      icon
                      :disabled="mobile_mode"
                      ><v-icon size="32">mdi-image-area</v-icon></v-btn
                    >
                  </template>
                  <template #prepend>
                    <v-btn
                      class="mt-n1"
                      @click="LZoomOut"
                      icon
                      :disabled="mobile_mode"
                    >
                      <v-icon size="20">mdi-image-area</v-icon></v-btn
                    >
                  </template>
                </v-slider>
              </v-card-text>
              <v-card-text v-if="logo_type_selected === 'normal'">
                <v-row no-gutters align="center">
                  <v-col cols="3">ขนาด : </v-col>
                  <v-col cols="9">
                    <v-slider
                      v-model="LogoSizeChange"
                      min="1"
                      max="100"
                      step="1"
                      hide-details=""
                    >
                      <template #append>
                        <v-btn @click="LZoomIn" icon
                          ><v-icon>mdi-magnify-plus-outline</v-icon></v-btn
                        >
                      </template>
                      <template #prepend>
                        <v-btn @click="LZoomOut" icon>
                          <v-icon>mdi-magnify-minus-outline</v-icon></v-btn
                        >
                      </template>
                    </v-slider>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-row class="my-3">
      <v-col cols="12" class="grow">
        <v-select
          v-model="login_selected"
          :items="login_type"
          label="รูปแบบการเข้าใช้งาน"
          outlined
          dense
          attach
          hide-details
          item-text="text"
          item-value="value"
          v-on:change="$emit('update:selected', login_selected)"
        ></v-select
      ></v-col>
    </v-row>
    <div class="my-5">รูปแบบธีม</div>
    <v-expansion-panels accordion multiple>
      <v-expansion-panel>
        <v-expansion-panel-header> พื้นหลังธีม </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <!-- <v-card-text class="pa-0">
              <v-checkbox
                v-model="welcome_theme.wc_fullwidth"
                label="เต็มความยาว"
                dense
                hide-details=""
              ></v-checkbox>
            </v-card-text> -->
            <v-card-text class="px-0"> สีพื้นหลังธีม </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="welcome_theme.wc_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          หัวข้อและรายละเอียด
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text class="pa-0">
              <v-radio-group
                v-model="welcome_theme.wc_justify"
                hide-details=""
                class="mt-0"
              >
                <template v-slot:label> รูปแบบการจัดวาง </template>
                <v-radio value="start">
                  <template v-slot:label>
                    <div>ชิดซ้าย</div>
                  </template>
                </v-radio>
                <v-radio value="center">
                  <template v-slot:label>
                    <div>ตรงกลาง</div>
                  </template>
                </v-radio>
                <v-radio value="end">
                  <template v-slot:label>
                    <div>ชิดขวา</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-card-text>
            <v-card-text class="px-0"> สีพื้นหลังหัวข้อ </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="welcome_theme.wc_bg_title"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-card-text class="pa-0"> สีชื่อหัวข้อ </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="welcome_theme.wc_title"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-card-text class="pa-0"> สีรายละเอียด </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="welcome_theme.wc_subtitle"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <DefaultTheme
      v-if="login_selected === 'normal'"
      class="my-5"
      :welcome_theme="welcome_theme"
    />
    <OneIDTheme
      v-if="login_selected === 'oneid'"
      class="my-5"
      :welcome_theme="welcome_theme"
    />
    <NotInTimeTheme
      v-if="login_selected === 'early' || login_selected === 'end'"
      class="my-5"
      :welcome_theme="welcome_theme"
      :login_selected="login_selected"
    />
    <ClosedTheme
      v-if="login_selected === 'closed'"
      class="my-5"
      :welcome_theme="welcome_theme"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import DefaultTheme from "./WelcomeType/DefaultTheme.vue";
import OneIDTheme from "./WelcomeType/OneIDTheme.vue";
import NotInTimeTheme from "./WelcomeType/NotInTimeTheme.vue";
import ClosedTheme from "./WelcomeType/ClosedTheme.vue";
// import CropImage from "./CropImage.vue";
const getBase64FromUrl = async (url) => {
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
};
export default {
  props: ["welcome_theme", "mobile_mode"],
  components: {
    DefaultTheme,
    OneIDTheme,
    NotInTimeTheme,
    ClosedTheme,
    // CropImage,
  },
  data() {
    return {
      imgURL: "",
      fileName: "",
      login_selected: "normal",
      login_type: [
        {
          text: "ปกติ",
          value: "normal",
        },
        {
          text: "Login with OneID",
          value: "oneid",
        },
        {
          text: "เข้ามาก่อนเวลา",
          value: "early",
        },
        {
          text: "เข้ามาหลังหมดเวลา",
          value: "end",
        },
        {
          text: "ปิดรับคำตอบ",
          value: "closed",
        },
      ],
      logo_type_selected: "banner",
      logo_type: [
        {
          text: "โลโก้",
          value: "normal",
        },
        {
          text: "แบนเนอร์",
          value: "banner",
        },
      ],
      logo_size: 100,
      expand_menu: {
        bg_color: true,
        bg_image: true,
        image: true,
      },
    };
  },
  watch: {
    welcome_theme: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && oldValue) {
          this.logo_type_selected = "banner";
          // if (newValue.image_size === "100%") {
          //   this.logo_type_selected = "banner";
          // } else {
          //   this.logo_type_selected = "normal";
          //   this.logo_size = Math.floor((newValue.image_size / 300) * 100);
          // }
        }
      },
    },
  },
  computed: {
    LogoSizeChange: {
      set: function (val) {
        if (this.welcome_theme.image_size === "100%") {
          this.welcome_theme.image_size = 50;
        } else {
          this.welcome_theme.image_size = val;
        }
      },
      get: function () {
        return this.welcome_theme.image_size;
      },
    },
  },
  mounted() {
    if (this.welcome_theme.image) {
      this.fileName = this.welcome_theme.image_url.match(
        /([\w\d_-]*)\.?[^\\/]*$/i
      )[1];
      getBase64FromUrl(this.welcome_theme.image_url).then((result) => {
        this.imgURL = result;
      });
    }
  },
  methods: {
    PopupCrop() {
      this.$refs.cropimage.OpenPopupCrop(this.imgURL, this.fileName);
    },
    LZoomOut() {
      this.LogoSizeChange = --this.welcome_theme.image_size;
    },
    LZoomIn() {
      this.LogoSizeChange = ++this.welcome_theme.image_size;
    },
    BGImage() {
      for (const key in this.$refs.bgimage.files) {
        if (Object.hasOwnProperty.call(this.$refs.bgimage.files, key)) {
          const element = this.$refs.bgimage.files[key];
          if (/\.(jpe?g|png|gif|svg)$/i.test(element.name)) {
            // element.name = element.name.replace(/ /g, "_");
            let vm = this;
            let formData = new FormData();
            formData.append("fileMax", 3);
            formData.append("fileData", element);
            formData.append(
              "filePath",
              `survey/${vm.$route.params.surveyID}-bgimage/question-end/`
            );
            formData.append("fileName", `${new Date().getTime()}-logo-`);
            vm.$store.dispatch("UploadFormData", formData).then((req) => {
              vm.welcome_theme.bg_image = true;
              vm.welcome_theme.bg_image_url = req.data
                .replace(/ /g, "%20")
                .replace(/\(/g, "%28")
                .replace(/\)/g, "%29");
              console.log(vm.welcome_theme.bg_image_url);
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "กรุณา upload แต่รูปภาพเท่านั้น",
              text: "รองรับ jpg, jpeg, png, gif, svg ",
            }).then(() => {
              this.$refs.bgimage.type = "text";
              this.$refs.bgimage.type = "file";
            });
          }
        }
      }
      this.$refs.bgimage.type = "text";
      this.$refs.bgimage.type = "file";
    },
    WebformImage() {
      for (const key in this.$refs.webformimage.files) {
        if (Object.hasOwnProperty.call(this.$refs.webformimage.files, key)) {
          const element = this.$refs.webformimage.files[key];
          if (/\.(jpe?g|png|gif|svg)$/i.test(element.name)) {
            let vm = this;
            let formData = new FormData();
            formData.append("fileMax", 3);
            formData.append("fileData", element);
            formData.append(
              "filePath",
              `survey/${vm.$route.params.surveyID}-image/question-end/`
            );
            formData.append("fileName", `${new Date().getTime()}-logo-`);
            vm.$store.dispatch("UploadFormData", formData).then((req) => {
              // this.$refs.cropimage.ResetImage();
              this.welcome_theme.image = true;
              vm.welcome_theme.image_url = req.data;
              vm.fileName = req.data.match(/([\w\d_-]*)\.?[^\\/]*$/i)[1];
              getBase64FromUrl(req.data).then((result) => {
                this.imgURL = result;
              });
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "กรุณา upload แต่รูปภาพเท่านั้น",
              text: "รองรับ jpg, jpeg, png, gif, svg ",
            }).then(() => {
              this.$refs.webformimage.type = "text";
              this.$refs.webformimage.type = "file";
            });
          }
        }
      }
      this.$refs.webformimage.type = "text";
      this.$refs.webformimage.type = "file";
    },
    ClearLogoImage() {
      this.welcome_theme.image = false;
      this.logo_type_selected = "banner";
      // this.logo_size = Math.floor((100 / 300) * 100);
      this.LogoSizeChange = "100%";
    },
  },
};
</script>

<style scoped>
.custom-panel >>> .v-expansion-panel-content__wrap {
  padding-right: 14px;
  padding-left: 12px;
}
</style>
